import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { StyledCard } from '@app/components/StyledCard';
import { useToast } from '@app/core/notifications';
import { yupResolver } from '@hookform/resolvers/yup';
import { AsyncView } from '@mi-front/ui';
import { Grid, Stack } from '@mui/material';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import * as yup from 'yup';
import { apiClient } from '../../../../api';

const auditConfigSchema = yup.object().shape({
  excludedCustomIds: yup.string().required(),
});

export const AuditConfigForm = () => {
  const { $t } = useIntl();
  const { notifySuccess } = useToast();

  return (
    <AsyncView promiseFn={() => apiClient.audit.configGet()}>
      {({ data }) => (
        <StyledCard
          title={$t({
            id: 'audit.auditConfig.materials',
            defaultMessage: 'Materiales',
          })}
        >
          <FormContainer
            values={{
              excludedCustomIds: data.excludedCustomIds.join(', '),
            }}
            resolver={yupResolver(auditConfigSchema)}
            onSuccess={async (formData) => {
              await apiClient.audit.configUpdate({
                excludedCustomIds: formData.excludedCustomIds
                  .split(',')
                  .map((s) => s.trim())
                  .filter((s) => !!s),
              });
              notifySuccess(
                $t({
                  id: 'audit.configScreen.successMessage',
                  defaultMessage: 'Audit config actualizada',
                }),
              );
            }}
          >
            <Stack useFlexGap>
              <Grid container spacing={2}>
                <Grid item md={9}>
                  <TextFieldElement
                    multiline
                    rows={5}
                    name="excludedCustomIds"
                    label={$t({
                      id: 'audit.configScreen.excludedCustomIds.label',
                      defaultMessage: 'Excluir ID material',
                    })}
                    helperText={$t({
                      id: 'audit.configScreen.excludedCustomIds.hint',
                      defaultMessage:
                        'Lista de custom IDs separados por coma que serán excluidos de los reportes de auditoría',
                    })}
                    fullWidth
                    required
                  />
                </Grid>
              </Grid>
              <FormActionsMui marginTop={1} />
            </Stack>
          </FormContainer>
        </StyledCard>
      )}
    </AsyncView>
  );
};
